import {Component, OnInit} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {Column, GridOption, AngularGridInstance} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';

@Component({
  selector: 'app-organisation',
  templateUrl: './organisation.component.html',
  styleUrls: ['./organisation.component.css']
})
export class OrganisationComponent implements OnInit {
  isCollapsed: boolean;
  displayed = true;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any[];
  angularGrid: AngularGridInstance;
  totalData: number;
  selectedTitles: any[];
  gridObj: any;
  show: boolean;
  selected: number;

  constructor(private messageService: MessageService, private route: Router) {
    // this.messageService.getNavberCollapseValue().subscribe(isCollapsed => {
    //   this.isCollapsed = isCollapsed;
    // });
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
    const classes = document.getElementsByClassName('search-filter');
    for (let i = 0; i < classes.length; i++) {
      classes[i].setAttribute('placeholder', '');
    }
  }

  ngOnInit() {
    this.columnDefinitions = [
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'name', name: 'Name', field: 'name', sortable: true, filterable: true, editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'zone', name: 'Zone', field: 'zone', sortable: true, filterable: true, editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'person', name: 'Key Person', field: 'person', sortable: true, filterable: true, editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'number', name: 'Cell Number', field: 'number', sortable: true, filterable: true, editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'email', name: 'Mail Id', field: 'email', sortable: true, filterable: true, editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'dfrom', name: 'Days From', field: 'dFrom', sortable: true, filterable: true, editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'dTo', name: 'Days To', field: 'dTo', sortable: true, filterable: true, editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'bFrom', name: 'Bussiness Hrs From', field: 'bFrom', sortable: true, filterable: true, editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'bTo', name: 'Bussiness Hrs To', field: 'bTo', sortable: true, filterable: true, editor: {
          model: CustomInputEditor,
        }
      }
    ];
    this.gridOptions = {
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false
      },
      enableCheckboxSelector: true,
      enableRowSelection: true
    };

    // fill the dataset with your data
    // VERY IMPORTANT, Angular-Slickgrid uses Slickgrid DataView which REQUIRES a unique
    // "id" and it has to be lowercase "id" and be part of the dataset
    this.dataset = [];
    // for demo purpose, let's mock a 1000 lines of data
    // for (let i = 0; i < 1000; i++) {
    //   const randomYear = 2000 + Math.floor(Math.random() * 10);
    //   const randomMonth = Math.floor(Math.random() * 11);
    //   const randomDay = Math.floor((Math.random() * 28));
    //   const randomPercent = Math.round(Math.random() * 100);
    //
    //   this.dataset[i] = {
    //     id: i, // again VERY IMPORTANT to fill the "id" with unique values
    //     title: 'Task ' + i,
    //     duration: Math.round(Math.random() * 100) + '',
    //     percentComplete: randomPercent,
    //     start: `${randomMonth}/${randomDay}/${randomYear}`,
    //     finish: `${randomMonth}/${randomDay}/${randomYear}`,
    //     effortDriven: (i % 5 === 0)
    //   };
    // }
  }

  changeRouting(path: string) {
    console.log(path);
    this.route.navigate(['user/' + path]);

  }

  toggleViews() {
    this.displayed = !this.displayed;
  }

  onCellChanged(e, args) {
    console.log(args.item);
  }

  getOrganizations() {
    this.dataset = [{
      id: 10052657,
      name: 'Mantech',
      zone: 'Asia/Kolkata',
      person: 'Ravi',
      number: '9676760288',
      email: 'ravi@stupa.co',
      dFrom: 'mon',
      dTo: 'sat',
      bFrom: '9:0',
      bTo: '18:0'
    }];
    this.totalData = this.dataset.length;
  }

  handleSelectedRowsChanged(e, args) {
    if (Array.isArray(args.rows)) {
      this.selectedTitles = args.rows.map(idx => {
        const item = this.gridObj.getDataItem(idx);
        return item || '';
      });
      if (this.selectedTitles.length > 0) {
        this.show = true;
        this.selected = this.selectedTitles.length;
      } else {
        this.show = false;
      }
      console.log(JSON.stringify(this.selectedTitles));
    }
  }
}
